// extracted by mini-css-extract-plugin
export var banner = "facebook-module--banner--287a5";
export var button = "facebook-module--button--8bf0b";
export var buttonHolder = "facebook-module--button-holder--3036f";
export var link = "facebook-module--link--da4e8";
export var privateGroupHolder = "facebook-module--private-group-holder--ffdaa";
export var publicGroupHolder = "facebook-module--public-group-holder--50a07";
export var span = "facebook-module--span--b8220";
export var text = "facebook-module--text--53437";
export var wrapper = "facebook-module--wrapper--e7c05";